module.exports = __webpack_public_path__ + "static/media/plus.72c19f73.svg";